import content from './content/fees-and-charges.json';

export const feesAndChargesMock = {
  name: 'fees-and-charges',
  layoutType: 1,
  areasList: [
    {
      id: 'fees-and-charges-main',
      componentName: 'Comp:FeesAndChargesPage',
      content: JSON.stringify(content)
    }
  ]
};
